import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../Styles/DayCampPaymentSuccess.scss';

function RetreatPaymentSuccess() {

   const location = useLocation();
   const navigate = useNavigate();
   const { paymentAmount, promoCode } = location.state || {};
   const isFreecamp = promoCode?.isSelected && promoCode?.discountPercent === 100;

   return (
      <div className="DayCampPaymentSuccessContainer">
         <div className="DayCampPaymentSuccessContent">
            {isFreecamp &&
               <div>
                  <div className="DayCampPaymentSuccessHeading">
                     Registration Successful!
                  </div>
                  <div className="DayCampPaymentSuccessAmount">
                     Your promo code covered the full cost of the retreat. No payment was required.
                  </div>
               </div>
            }
            {!isFreecamp && paymentAmount == 0 &&
               <div className="DayCampPaymentSuccessHeading">
                  Registration Successful!
               </div>
            }
            {!isFreecamp && paymentAmount > 0 &&
               <div>
                  <div className="DayCampPaymentSuccessHeading">
                     Thank You For Your Payment!
                  </div>
                  <div className="DayCampPaymentSuccessAmount">
                     Amount: ${Number(paymentAmount).toFixed(2)}
                  </div>
               </div>
            }
            <div className="DayCampPaymentSuccessRedirectButton">
               <button onClick={() => navigate('/individualaccount')}>
                  Return to Dashboard
               </button>
            </div>
         </div>
      </div>
   )
}

export default RetreatPaymentSuccess;
